var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"tabs"},_vm._l((_vm.tabs),function(tab,i){return _c('li',{key:i,staticClass:"tabs__item"},[_c('button',{staticClass:"btn tabs__btn",class:{ 'is-active': tab.isActive },on:{"click":function($event){return _vm.selectTab(i)}}},[_vm._v(" "+_vm._s(tab.name)+" ")])])}),0),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }